import { FilterModel } from 'ag-grid-community';
import { QuickFilterModel } from './quick-filters/quick-filter-models';

export const activeRecordFilter: FilterModel = QuickFilterModel.Active;
